import useIsMobile from '@/hooks/useIsMobile';
import VoucherListDesktop from './desktop';
import VoucherListMobile from './mobile';
import useList from './useList';

const VoucherList = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useList();

  if (isMobile) {
    return <VoucherListMobile viewModel={viewModel} />;
  }

  return <VoucherListDesktop viewModel={viewModel} />;
};

export default VoucherList;